<template>
  <v-app>
    <div
      class="d-flex justify-center align-center"
      style="height: 100vh;"
      v-if="!userLoggedIn
      && !$route.params.token
      && $route.name !== '401' && $route.name !== 'signin cognito'
      && $route.name !== 'visor-panorama detail'">
      <Loading size="50"></Loading>
    </div>
    <vue100vh v-else :css="{ display: 'flex',flexDirection: 'column', height: '100rvh' }">
      <v-system-bar
        v-if="showSystemBar && $route.name && $route.name.includes('project-startup')"
        app height="auto"
        dark class="subtitle-1 d-flex flex-column px-0"
      >
        <div class="py-2 px-6 d-flex justify-center align-center purple darken-2"
          style="width: 100%">
          <v-icon class="mr-2" color="white">mdi-bell</v-icon>
          <span class="font-weight-bold white--text">
            Please note that access to the BIM360  project location and permission
            assignment for project members is the responsibility of the lead Site
            Adapt Architect/Architect of  Record
          </span>
          <v-btn color="white" class="ml-2" icon @click="showSystemBar = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-system-bar>
      <DialogHelp v-if="userLoggedIn"></DialogHelp>
      <application-list v-if="$route.name !== '401'"></application-list>
      <app-bar v-if="!isViewerApp
        && $route.name !== '401'
        && $route.name !== 'signin cognito'
        && $route.name !== 'visor-panorama detail'" :profile="profile">
      </app-bar>
      <v-main :class="{ 'pa-0': isViewerApp }">
        <router-view></router-view>
      </v-main>
      <v-snackbar
        v-model="showDownloadsComputed"
        :timeout="-1"
        right
        color="primary"
      >
        <v-sheet
          class="ma-0 mb-2"
          color="primary"
          width="320"
          tile
          elevation="0"
        >
          <div @click.stop="setExpandDownloads(!expandDownloads)"
            class="d-flex align-center pointer pl-4 pr-2 py-1">
            <span class="white--text">Downloads</span>
            <v-spacer></v-spacer>
            <v-btn @click.stop="setShowDownloads(false)" small icon color="white">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-list
            v-if="expandDownloads"
            dense
            tile
            class="white"
            style="border-radius: 0; max-height: 300px; overflow: auto;"
          >
            <v-list-item
              two-line
              v-for="(download, index) in downloads"
              :key="index"
              light
            >
              <v-progress-circular v-if="download.status === 'progress'"
                :width="2"
                size="15"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <v-icon
                v-if="download.status === 'complete'"
                color="success"
                small
              >
                mdi-check-circle
              </v-icon>
              <v-icon
                v-if="download.status === 'error'"
                color="error"
                small
              >
                mdi-close
              </v-icon>
              <v-list-item-content class="ml-4">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on">{{ download.name }}</v-list-item-title>
                  </template>
                  <span>{{ download.name }}</span>
                </v-tooltip>
                <v-list-item-subtitle class="caption" style="font-size: 10px !important">
                  {{ bytesToSize(download.bytes) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-snackbar>
      <!-- <div style="width: 100%; position: relative">
      </div> -->
    </vue100vh>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import vue100vh from 'vue-100vh';
import AppBar from '@/components/AppBar.vue';
import ApplicationList from '@/components/ApplicationList.vue';
import Loading from '@/components/Loading.vue';
import DialogHelp from '@/components/DialogHelp.vue';

export default {
  name: 'App',
  components: {
    'app-bar': AppBar,
    'application-list': ApplicationList,
    vue100vh,
    Loading,
    DialogHelp,
  },
  data() {
    return {
      showSystemBar: true,
    };
  },
  computed: {
    ...mapState('profile', ['userLoggedIn']),
    ...mapState(['showDownloads', 'expandDownloads', 'downloads', 'dialogShowHelp']),
    ...mapGetters('profile', ['userLoggedInFullName', 'isLoggedIn', 'userLoggedInImage']),
    profile() {
      if (!this.userLoggedIn) return {};
      const profile = this.userLoggedIn;
      profile.fullName = this.userLoggedInFullName;
      profile.image = this.userLoggedInImage;
      return profile;
    },
    isViewerApp() {
      return this.$route.name ? this.$route.name.startsWith('viewer') : false;
    },
    showDownloadsComputed: {
      get() { return this.showDownloads; },
      set(value) { this.setShowDownloads(value); },
    },
  },
  methods: {
    ...mapMutations(['setShowDownloads', 'setExpandDownloads', 'setDialogShowHelp']),
    bytesToSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      return `${(bytes / (1024 ** i)).toFixed(2)} ${sizes[i]}`;
    },
  },
};
</script>

<style>
  * {
    font-family: 'Lato', sans-serif;
    outline: none;
  }

  [v-cloak] {display: none}

  .pointer {
    cursor: pointer;
  }

  .absolute {
    position: absolute;
  }

  .word-break {
    word-break: break-word;
  }

  a {
    text-decoration: none;
  }

  .show-env-bg-button {
    background: red;
  }

  .hide-env-bg-button {
    background: blue;
  }

  .dot {
    position: relative;
    background-color: transparent;
    border-radius: 5px;
    font-size: 0;
    margin-left: 20px;
    padding: 5px;
  }
</style>
